// extracted by mini-css-extract-plugin
module.exports = {"MonthlyStatementsPage":"monthlyStatements_MonthlyStatementsPage__2QJ9E","Content":"monthlyStatements_Content__1OVO4","FillerImage":"monthlyStatements_FillerImage__3ea6r"};